export default [
  {
    content: "안전인증 및 안전검사 수검 여부 확인",
    isChecked: "",
  },
  {
    content: "크레인 정격하중 초과 시 과부하방지 장치 정상 작동 여부",
    isChecked: "",
  },
  {
    content: "권과방지장치 정상 작동 여부",
    isChecked: "",
  },
  {
    content: "훅 해지장치 부착상태 확인",
    isChecked: "",
  },
  {
    content: "비상정지장치 버튼 파손 여부 및 정상작동 확인",
    isChecked: "",
  },
  {
    content: "와이어로프, 체인, 줄걸이 용구 마모, 변형, 부식 및 손상 확인",
    isChecked: "",
  },
  {
    content: "중량물 인양 시 적합한 줄걸이 용구 사용 확인",
    isChecked: "",
  },
  {
    content: "중량물 취급에 따른 보호구(안전모, 안전화 등) 착용 확인\n" +
      "(점검 등 레일 위 고소작업 시 안전대 착용)",
    isChecked: "",
  },
  {
    content: "크레인 지정 운전자만 조작하도록 관리",
    isChecked: "",
  },
  {
    content: "중량물 취급 시 주변 근로자 통제",
    isChecked: "",
  },
  {
    content: "운전 시 일정한 신호방법 규정 및 준수",
    isChecked: "",
  },
];
